import { Box, Button } from '@chakra-ui/react'
import type { Addon, BaseParamsDto, InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { RiskVariant } from 'BrokerTsLib/src/enums'
import { FormProvider, useForm, yupResolver } from 'BrokerTsLib/src/rhf'
import { useContext } from 'react'
import * as yup from 'yup'

import { FormSpacer } from '../../components/FormSpacer'
import { InsuranceCompanies } from '../../components/InsuranceCompanies'
import { carkulkaOffersContext } from '../../context/CarkulkaOffersProvider'
import { useInsurers } from '../../hooks'
import { useNameof } from '../../hooks/useNameof'
import { useAddVariant } from '../../hooks/useWizard'
import { Add } from '../../icons'
import { insuranceParamsContext } from '../../layouts/Wizard'
import { scrollToOfferWithOffset as scrollToElementId } from '../offers/OfferCar'
import { InsuranceType } from './InsuranceType'

type okAppsBaseParamsVehicleDto = BaseParamsDto & {
  addons: Addon[]
}

export const NewInsuranceSettings = () => {
  const nameof = useNameof<okAppsBaseParamsVehicleDto>()

  const { insuranceParams: insuranceParamsGeneric, insuranceParamsId } = useContext(insuranceParamsContext) ?? {}
  const insuranceParams = insuranceParamsGeneric as InsuranceParamsDto
  const { refetchOffers: getOffers } = useContext(carkulkaOffersContext) ?? {}
  const { mutateAsync: createVariant } = useAddVariant(insuranceParamsId!)



  const methods = useForm<okAppsBaseParamsVehicleDto>({
    defaultValues:
    {
      ...insuranceParams!.baseParams,
      addons: insuranceParams?.addons ?? []
    },
    resolver: yupResolver(yup.object().shape({})) as any, // aby se pripadne resetovaly serverove validace
    mode: 'onBlur',
  })

  const hasHav = (insuranceParams?.baseParams?.hav?.filter(x => x != RiskVariant.WithoutHAV)?.length ?? 0) > 0

  const { handleSubmit, formState: { isSubmitting } } = methods

  const onSubmitForm = handleSubmit((values: okAppsBaseParamsVehicleDto) => {

    return createVariant(values)
      .then(() => {
        getOffers()
        scrollToElementId('steps')
      })
  })

  const { data: allInsurers, isLoading: isLoadingInsurers, isFetching: isFetchingInsurers } = useInsurers(false, null)

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmitForm}>
        <Box sx={{ display: 'grid', gap: 4, placeItems: 'start' }}>
          <InsuranceType isContracted={!!insuranceParams?.generalParams.contractNumber} showHav={hasHav} />

          <FormSpacer />

          <InsuranceCompanies
            companies={(allInsurers ?? [])}
            isLoadingCompanies={(isFetchingInsurers || isLoadingInsurers)}
            propPath={nameof(x => x.insurers)}
          />

          <Button type="submit" variant="outline" isLoading={isSubmitting} isDisabled={isSubmitting}>
            <Add color="secondary.500" />
            Přidat do kalkulace
          </Button>
        </Box>
      </form>
    </FormProvider>
  )
}
